import React from 'react';
import { useParams } from 'react-router';
import { TransactionsView } from './TransactionsView';
import { familyCurrenciesApi } from '../api/familyCurrencies';

export const FamilyCurrencyTransactionsPage = () => {
  const { currencyId } = useParams();
  return (
    <TransactionsView
      currencyId={Number(currencyId)}
      api={familyCurrenciesApi}
      backHref="/family-currencies"
    />
  );
};

export default FamilyCurrencyTransactionsPage;
